module.exports = __webpack_public_path__ + "static/media/back_arrow.8efb0335.svg";